import { render, staticRenderFns } from "./LimitNumbers.vue?vue&type=template&id=fbccd91e&scoped=true&"
import script from "./LimitNumbers.vue?vue&type=script&lang=js&"
export * from "./LimitNumbers.vue?vue&type=script&lang=js&"
import style0 from "./LimitNumbers.vue?vue&type=style&index=0&id=fbccd91e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbccd91e",
  null
  
)

export default component.exports